
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Projects = lazy(() => import('../pages/projects/page'));
const Growth = lazy(() => import('../pages/growth/page'));
const InjectionMolding = lazy(() => import('../pages/injection-molding/page'));
const BlowMolding = lazy(() => import('../pages/blow-molding/page'));
const ThreeDPrinting = lazy(() => import('../pages/3d-printing/page'));
const News = lazy(() => import('../pages/news/page'));
const Careers = lazy(() => import('../pages/careers/page'));
const About = lazy(() => import('../pages/about/page'));
const Resources = lazy(() => import('../pages/resources/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/projects',
    element: <Projects />,
  },
  {
    path: '/growth',
    element: <Growth />,
  },
  {
    path: '/injection-molding',
    element: <InjectionMolding />,
  },
  {
    path: '/blow-molding',
    element: <BlowMolding />,
  },
  {
    path: '/3d-printing',
    element: <ThreeDPrinting />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '/careers',
    element: <Careers />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/resources',
    element: <Resources />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
